<template>
    <b-form-group label-for="skinType">
        <template slot="label"
            >{{ $t("pages.forms.skin.skin-type.title")
            }}<span v-if="required" :class="requiredClasses">*</span></template
        >
        <validation-provider
            :rules="{ required }"
            v-slot="{ classes, valid, validated, dirty, errors }"
        >
            <multiselect
                id="skinType"
                v-model="skinType"
                :options="skinTypeOptions"
                :multiple="true"
                :close-on-select="true"
                :clear-on-select="false"
                :preserve-search="true"
                :taggable="true"
                :placeholder="$t('pages.forms.select-descriptors.placeholder')"
                :deselectLabel="
                    $t('pages.forms.select-descriptors.deselectlabel')
                "
                :selectedLabel="
                    $t('pages.forms.select-descriptors.selectedlabel')
                "
                :selectLabel="$t('pages.forms.select-descriptors.selectlabel')"
                label="text"
                track-by="value"
                openDirection="above"
                :class="classes"
                :maxHeight="350"
                @input="update"
                v-show="!isReviewing"
                data-cypress-id="skin-type"
            />
            <div v-if="(dirty || validated) && !valid" class="invalid-feedback">
                {{ errors[0] }}
            </div>
        </validation-provider>
        <b-form-input
            type="text"
            readonly
            plaintext
            v-show="isReviewing"
            :value="skinTypeValue"
        />
    </b-form-group>
</template>

<script>
import FormInputHelpers from "../../../../../mixins/FormInputHelpers";
import { ValidationProvider } from "vee-validate";

export default {
    mixins: [FormInputHelpers],
    components: { ValidationProvider },
    data() {
        return {
            skinType: this.value
        };
    },
    props: {
        value: null,
        required: {
            type: Boolean,
            default: false
        },
        reviewing: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        update(value) {
            this.$emit("input", value);
        }
    },
    computed: {
        skinTypeOptions() {
            return [
                {
                    value: 1,
                    text: this.$i18n.t("pages.forms.skin.skin-type.options.op1")
                },
                {
                    value: 2,
                    text: this.$i18n.t("pages.forms.skin.skin-type.options.op2")
                },
                {
                    value: 3,
                    text: this.$i18n.t("pages.forms.skin.skin-type.options.op3")
                },
                {
                    value: 4,
                    text: this.$i18n.t("pages.forms.skin.skin-type.options.op4")
                },
                {
                    value: 5,
                    text: this.$i18n.t("pages.forms.skin.skin-type.options.op5")
                }
            ];
        },
        isReviewing() {
            return this.reviewing;
        },
        skinTypeValue() {
            if (this.skinType != null) {
                return this.skinType.map(e => e.text).join(", ");
            }
            return this.skinType;
        }
    }
};
</script>
